import { useEffect, useState } from "react";
import HeaderComponent from "../header";
import Cards from "./cards";
import CustomersGraph from "./customers";
import TransactionsGraph from "./transactions";
const Dashboard = () => {
    const [breadCrumbList, setBreadCrumbList] = useState();
    useEffect(() => {
        breadCrumbSetUp()
    }, [])
    const breadCrumbSetUp = () => {
        setBreadCrumbList([{ id: '1', bname: 'Dashboard', url: "" },
        ])
    }
    return (
        <div className="">
            <HeaderComponent breadCrumbList={breadCrumbList} />
            <div className=" mt-7">
                <h3 className="text-2xl font-semibold text-titleColor mb-1.5">{'Cards'}</h3>
                <Cards />
            </div>
            <div className=" mt-7">
                <h3 className="text-2xl font-semibold text-titleColor mb-1.5">{'Customers'}</h3>
                <CustomersGraph />
            </div>
            <div className=" mt-7">
                <h3 className="text-2xl font-semibold text-titleColor mb-1.5">{'Transactions'}</h3>
                <TransactionsGraph />
            </div>
        </div>
    );
};
export default Dashboard;
